import {
    Component, OnInit, ViewEncapsulation,
    OnDestroy, Input, Output,
    Renderer, EventEmitter
} from '@angular/core';
import { DomUtil } from '../util/dom-handler.service';

@Component({
    selector: 'jui-dropdown',
    template: `
        <div class="ui-dropdown-container" #container
            (mouseenter)="onDropdownHandler($event, dropdown, container)"
            (mouseleave)="onMouseLeave($event, dropdown, container)"
            (click)="onDropdownHandler($event, dropdown, container)">
            <ng-content></ng-content>
            <div class="ui-dropdown" #dropdown
                [style.display]="dropdownVisible ? 'block' : 'none'"
                [style.max-height]="_maxHeight">
                <ul class="ui-dropdown-items">
                    <li class="ui-dropdown-item" *ngFor="let item of dataSource"
                        [class.active]="item===chosen"
                        [style.min-width.px]="width">
                        <a [href]="item.url||'javascript:void(0);'" 
                        [ngClass]="{'ui-dropdown-item-link':true,
                        'ui-dropdown-item-disabled':item.disabled}" 
                        (click)="itemClick($event,item)"
                        [style.color]="item.color">
                            <span class="ui-dropdown-item-text">{{item.label}}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    `,
    styles: [`
      @font-face {
        font-family: 'iconfont';
        /* project id 290315 */
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot");
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot?#iefix") format("embedded-opentype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.woff") format("woff"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.ttf") format("truetype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.svg#iconfont") format("svg"); }

      .iconfont {
        display: inline-block;
        vertical-align: baseline;
        font-family: "iconfont" !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale; }

      .icon-jui-alert:before {
        content: "\\e600"; }

      .icon-jui-search:before {
        content: "\\e630"; }

      .icon-jui-paper3:before {
        content: "\\e652"; }

      .icon-jui-setting:before {
        content: "\\e602"; }

      .icon-jui-left2:before {
        content: "\\e697"; }

      .icon-jui-wrong:before {
        content: "\\e69a"; }

      .icon-jui-up2:before {
        content: "\\e6a5"; }

      .icon-jui-down2:before {
        content: "\\e6a6"; }

      .icon-jui-right2:before {
        content: "\\e6a7"; }

      .icon-jui-correct2:before {
        content: "\\e627"; }

      .icon-jui-qq:before {
        content: "\\e63a"; }

      .icon-jui-email:before {
        content: "\\e62a"; }

      .icon-jui-edit:before {
        content: "\\e686"; }

      .icon-jui-download2:before {
        content: "\\e714"; }

      .icon-jui-speaker:before {
        content: "\\e85c"; }

      .icon-jui-add:before {
        content: "\\e609"; }

      .icon-jui-msg:before {
        content: "\\e613"; }

      .icon-jui-minus:before {
        content: "\\e601"; }

      .icon-jui-up:before {
        content: "\\e658"; }

      .icon-jui-letter-open:before {
        content: "\\e61d"; }

      .icon-jui-down:before {
        content: "\\ed22"; }

      .icon-jui-info:before {
        content: "\\e685"; }

      .icon-jui-cross2:before {
        content: "\\e6b4"; }

      .icon-jui-paper2:before {
        content: "\\e71e"; }

      .icon-jui-loading:before {
        content: "\\eee3"; }

      .icon-jui-road-sign:before {
        content: "\\e604"; }

      .icon-jui-left:before {
        content: "\\e66a"; }

      .icon-jui-letter:before {
        content: "\\e605"; }

      .icon-jui-right:before {
        content: "\\e64d"; }

      .icon-jui-back-top:before {
        content: "\\e628"; }

      .icon-jui-dropdown:before {
        content: "\\e75a"; }

      .icon-jui-down3:before {
        content: "\\e629"; }

      .icon-jui-alarm:before {
        content: "\\e6c2"; }

      .icon-jui-paper:before {
        content: "\\e612"; }

      .icon-jui-cross:before {
        content: "\\e6b0"; }

      .icon-jui-correct:before {
        content: "\\e6b3"; }

      .icon-jui-up3:before {
        content: "\\eee4"; }

      .icon-jui-username:before {
        content: "\\e670"; }

      .icon-jui-password:before {
        content: "\\e615"; }

      .icon-jui-slideLeft:before {
        content: "\\e603"; }

      .icon-jui-slideRight:before {
        content: "\\e641"; }

      /* icon Animate */
      .icon-doTurn {
        -webkit-animation: doTurn 1s infinite linear;
        animation: doTurn 1s infinite linear; }

      @-webkit-keyframes doTurn {
        0% {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(0deg); }
        to {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(1turn); } }

      @keyframes doTurn {
        0% {
          transform-origin: 50% 50%;
          transform: rotate(0deg); }
        to {
          transform-origin: 50% 50%;
          transform: rotate(1turn); } }
      jui-dropdown .ui-dropdown-container {
        position: relative;
        display: inline-block;
        cursor: pointer; }

      jui-dropdown .ui-dropdown {
        z-index: 1;
        position: absolute;
        left: -9999px;
        top: -9999px;
        font-size: 12px;
        font-weight: 400;
        line-height: 1.5; }

      jui-dropdown .ui-dropdown-items {
        outline: none;
        position: relative;
        list-style-type: none;
        padding: 0;
        margin: 0;
        text-align: left;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
        background-clip: padding-box; }

      jui-dropdown .ui-dropdown-item {
        padding: 7px 16px;
        margin: 0;
        clear: both;
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        white-space: nowrap;
        cursor: pointer;
        -webkit-transition: all .3s;
        transition: all .3s; }

      jui-dropdown .ui-dropdown-item.active {
        background: rgba(3, 102, 214, 0.2); }

      jui-dropdown .ui-dropdown-item:first-child {
        border-radius: 4px 4px 0 0; }

      jui-dropdown .ui-dropdown-item:last-child {
        border-radius: 0 0 4px 4px; }

      jui-dropdown .ui-dropdown-item:hover {
        background-color: #ecf6fd; }

      jui-dropdown .ui-dropdown-item-link {
        color: rgba(0, 0, 0, 0.65);
        display: block;
        padding: 7px 16px;
        margin: -7px -16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap; }

      jui-dropdown .ui-dropdown-item-disabled {
        color: rgba(0, 0, 0, 0.25);
        cursor: not-allowed; }

      jui-dropdown .ui-dropdown-item-disabled:hover {
        background-color: #fff; }

      /* .ui-dropdown-item-text{
	
      } */
    `],
    encapsulation: ViewEncapsulation.None
})
export class DropdownComponent implements OnInit, OnDestroy {
    // 触发方式
    @Input()
    public trigger: string;
    // 选项的宽度
    @Input()
    public width: number;
    // 数据源
    @Input()
    public dataSource: any[];
    @Input()
    public set maxHeight(data: number | string) {
        if (typeof data === 'number') {
            this._maxHeight = data + 'px';
        }
    }
    @Output()
    public selectChange: EventEmitter<any> = new EventEmitter();
    // 传递到父组件
    @Output()
    public getDropdownVisible: EventEmitter<any> = new EventEmitter();
    @Input()
    public chosen: any;

    public dropdownVisible = false;
    public _maxHeight: string;
    private isOpen = false;
    private documentClickListener: any;

    constructor(
        private renderer: Renderer
    ) { }

    public ngOnInit() {
        // pass
    }

    public ngOnDestroy() {
        this.unbindDocument();
    }

    public onMouseLeave(event: Event, dropdown: HTMLDivElement, container: Element) {
        if (!this.trigger || this.trigger === 'hover') {
            this.dropdownVisible = false;
            // 传递到父组件
            this.getDropdownVisible.emit(this.dropdownVisible);
        }
    }

    public onDropdownHandler(event: Event, dropdown: HTMLDivElement, container: Element) {
        if (!this.trigger
            || (this.trigger === 'hover' && event.type === 'mouseenter')
            || event.type === this.trigger) {
                event.stopPropagation();
                this.dropdownVisible = !this.dropdownVisible;
                DomUtil.relativePosition(dropdown, container);
                DomUtil.fadeIn(dropdown, 100);
                if (this.dropdownVisible) {
                    this.bindDocument();
                }
                // 传递到父组件
                this.getDropdownVisible.emit(this.dropdownVisible);
        }
    }

    public itemClick(event: Event, item: any)  {
        if (item.disabled) {
            event.preventDefault();
            return;
        }
        this.selectChange.emit(item);
        this.chosen = item;

        if (!item.url || item.routerLink) {
            event.preventDefault();
        }

        if (item.command) {
            let data = {
                item,
                event
            };
            if (!item.eventEmitter) {
                item.eventEmitter = new EventEmitter();
                item.eventEmitter.subscribe(item.command);
            }

            item.eventEmitter.emit(data);
        }
        this.dropdownVisible = false;
        // 传递到父组件
        this.getDropdownVisible.emit(this.dropdownVisible);
        event.stopPropagation();
    }

    private bindDocument() {
        if (!this.documentClickListener) {
            this.documentClickListener =
                DomUtil.bindBodyClick(this.renderer, (e) => {
                    this.dropdownVisible = false;
                    // 传递到父组件
                    this.getDropdownVisible.emit(this.dropdownVisible);
                    this.unbindDocument();
            });
        }
    }

    private unbindDocument() {
        if (this.documentClickListener) {
            this.documentClickListener();
            this.documentClickListener = null;
        }
    }
}
